import {create} from 'zustand';
import {type AudioRecordsType, HiveSoundsState} from './types';
import {$api} from 'shared/api';

export const useHivesSoundsStore = create<HiveSoundsState>((set) => ({
  items: [],
  countAlarms: 0,
  getAudiosFromServer: async (apiaryId, page, size) => {
    if (!apiaryId) return {items: [], total: 0};

    const res = await $api
      .get<AudioRecordsType>(`/collector/audio-records/apiaries/${apiaryId}`, {
        params: {
          'page[size]': size ?? 100,
          'page[index]': page ?? 0,
        },
      })
      .catch(console.warn);

    const items = res?.data.items || [];
    const total = res?.data.total ?? 0;
    const countAlarms = res?.data.countAlarms || 0;

    set({
      items,
      countAlarms,
    });

    return {items, total};
  },
}));
